(ns kyber.subscriptions.media-player
  (:require [re-frame.core :as re-frame]
            [kyber.db.media-player :as media-player-db]))

(defn player [db [_ player-key]]
  (media-player-db/db->media-player-player db player-key))

(re-frame/reg-sub :media-player/player player)

(defn player-attributes [db [_ player-key]]
  (media-player-db/db->media-player-attributes db player-key))

(re-frame/reg-sub :media-player/player-attributes player-attributes)

(defn player-keys [db]
  (media-player-db/db->media-player-keys db))

(re-frame/reg-sub :media-player/player-keys player-keys)
